import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

/* Layout */
import Layout from '@/layout'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/config',
    children: [
      {
        path: 'config',
        component: () => import('@/views/config/config.vue'),
        name: 'config',
        meta: { requireAuth: true, title: '交易配置' }
      },
      {
        path: 'robotList',
        component: () => import('@/views/robotList/robotList.vue'),
        name: 'robotList',
        meta: { requireAuth: true, title: '机器人管理' }
      },
      {
        path: 'ordermanagement',
        component: () => import('@/views/ordermanagement/ordermanagement.vue'),
        name: 'ordermanagement',
        meta: { requireAuth: true, title: '带单管理' }
      }
    ],
  },
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    // console.log(getToken())
    if (!!getToken()) {
      next()
    } else {
      // next()
      // 未登录
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }
  } else {
    // 如果进入不需要登录权限的页面时
    // 有token，则免登陆
    // if (!!getToken()) {
    //   // 否则，自动跳转到其他页面
    //   next({ path: '/' });
    // } else {
    next()
    // }
  }
})


export default router
